/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
} from '../../../../../SharedModules/CommonConstants/commonConstants';
import {
  dispatchCheckAllocatePaymentDetails,
  handleErrorMessageForAllocatePayment,
  setSearchScreenTab,
} from '../../store/Actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';

export default (props) => {
  const { state, setState, handleSearchForChecksGrid } = props;
  const dispatch = useDispatch();
  const errorMessagesFromRedux = useSelector(
    (reduxState) =>
      reduxState?.sharedState?.AllocatePaymentReducer?.errorMessagesInRedux
  );
  const searchScreenTabData = useSelector(
    (reduxState) =>
      reduxState.sharedState.AllocatePaymentReducer?.searchScreenObj
  );

  const handleOnSubmit = () => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (state?.fromDate === null || state?.fromDate === '') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'loggedByOther' &&
          item.field !== 'checkPayeeCd' &&
          item.field !== 'fromDate' &&
          item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'fromDate',
        errorType: 'fromDateRequired',
        message: constantMessageData.FROM_DATE_REQUIRED,
      });
    } else if (state?.toDate === null || state?.toDate === '') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'loggedByOther' &&
          item.field !== 'checkPayeeCd' &&
          item.field !== 'toDate' &&
          item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'toDate',
        errorType: 'toDateRequired',
        message: constantMessageData.TO_DATE_REQUIRED,
      });
    } else if (
      validDate(new Date(state?.fromDate)) &&
      compareTwoDatesGreaterThanOrEqual(state?.fromDate, moment(MinDate))
    ) {
      localErr = localErr.filter((item) => item.field !== 'fromDate');
      localErr.push({
        field: 'fromDate',
        errorType: 'lessThanError',
        message: constantMessageData.FROM_DATE_LESS_THAN_ERROR,
      });
    } else if (
      validDate(new Date(state?.toDate)) &&
      validDate(new Date(state?.fromDate)) &&
      compareTwoDatesGreaterThanOrEqual(
        new Date(state.toDate),
        moment(new Date(state?.fromDate))
      )
    ) {
      localErr = localErr.filter((item) => item.field !== 'toDate');
      localErr.push({
        field: 'toDate',
        errorType: 'lessThanError',
        message: constantMessageData.TO_DATE_GREATER_THAN_FROM_DATE,
      });
    } else {
      localErr = localErr.filter(
        (item) => item.field !== 'fromDate' && item.field !== 'toDate'
      );
      dispatch(dispatchCheckAllocatePaymentDetails([]));
      handleSearchForChecksGrid('dateFilter');
    }
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
  };
  const handleChangeDate = (d, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (d?.target?.value) {
      let value = autoFormateDate(d?.target?.value);
      if (value && value?.length > 5) {
        const data = value?.split('/');
        if (data[2]?.split('_')?.length === 3) {
          value = moment(value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value =
            d?.target?.value !== '' ? autoFormateDate(d?.target?.value) : null;
        }
      }
      if (name === 'fromDate') {
        if (value === '' || value === null) {
          setState({ ...state, [name]: value });
          dispatch(
            setSearchScreenTab({
              ...searchScreenTabData,
              state: { ...state, [name]: value },
            })
          );
          localErr = localErr.filter((item) => item.field !== 'fromDate');
          localErr.push({
            field: 'fromDate',
            errorType: 'fromDateRequired',
            message: constantMessageData.FROM_DATE_REQUIRED,
          });
        } else if (validDate(new Date(value)) === false) {
          setState({ ...state, [name]: value });
          dispatch(
            setSearchScreenTab({
              ...searchScreenTabData,
              state: { ...state, [name]: value },
            })
          );
          localErr = localErr.filter((item) => item.field !== 'fromDate');
          localErr.push({
            field: 'fromDate',
            errorType: 'dateInvalidFormat',
            message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
          });
        } else if (
          validDate(new Date(value)) &&
          compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
        ) {
          setState({ ...state, [name]: value });
          localErr = localErr.filter((item) => item.field !== 'fromDate');
          localErr.push({
            field: 'fromDate',
            errorType: 'lessThanError',
            message: constantMessageData.FROM_DATE_LESS_THAN_ERROR,
          });
        } else if (
          validDate(new Date(state?.toDate)) &&
          compareTwoDatesGreaterThanOrEqual(
            new Date(state.toDate),
            moment(new Date(value))
          )
        ) {
          localErr = localErr.filter((item) => item.field !== 'toDate');
          localErr.push({
            field: 'toDate',
            errorType: 'lessThanError',
            message: constantMessageData.TO_DATE_GREATER_THAN_FROM_DATE,
          });
          setState({ ...state, [name]: value });
          dispatch(
            setSearchScreenTab({
              ...searchScreenTabData,
              state: { ...state, [name]: value },
            })
          );
        } else {
          if (
            name === 'fromDate' &&
            (state.toDate === null ||
              state.toDate === '' ||
              state.toDate == 'Invalid Date')
          ) {
            setState({ ...state, [name]: value, toDate: value });
            dispatch(
              setSearchScreenTab({
                ...searchScreenTabData,
                state: { ...state, [name]: value, toDate: value },
              })
            );
          } else {
            localErr = localErr.filter((item) => item.field !== 'fromDate');
            setState({ ...state, [name]: value });
            dispatch(
              setSearchScreenTab({
                ...searchScreenTabData,
                state: { ...state, [name]: value },
              })
            );
          }
        }
      } else if (value === '' || value === null) {
        setState({ ...state, [name]: value });
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: value },
          })
        );
        localErr = localErr.filter((item) => item.field !== 'toDate');
        localErr.push({
          field: 'toDate',
          errorType: 'fromDateRequired',
          message: constantMessageData.TO_DATE_REQUIRED,
        });
      } else if (validDate(new Date(value)) === false) {
        localErr = localErr.filter((item) => item.field !== 'toDate');
        localErr.push({
          field: 'toDate',
          errorType: 'dateInvalidFormat',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
        setState({ ...state, [name]: value });
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: value },
          })
        );
      } else if (
        value &&
        validDate(new Date(state?.fromDate)) &&
        compareTwoDatesGreaterThanOrEqual(
          moment(new Date(value)),
          moment(new Date(state?.fromDate))
        )
      ) {
        localErr = localErr.filter((item) => item.field !== 'toDate');
        localErr.push({
          field: 'toDate',
          errorType: 'lessThanError',
          message: constantMessageData.TO_DATE_GREATER_THAN_FROM_DATE,
        });
        setState({ ...state, [name]: value });

        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: value },
          })
        );
      } else {
        setState({ ...state, [name]: value });
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: value },
          })
        );
      }
    }
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
  };
  // handing on change date event
  const handleOnChangeDateFields = (d, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (d !== 'Invalid Date') {
      localErr = localErr.filter(
        (item) => item.field !== 'toDate' && item.field !== 'fromDate'
      );
      if (
        (name === 'fromDate' && state.toDate === null) ||
        state.toDate === '' ||
        state.toDate == 'Invalid Date'
      ) {
        setState({ ...state, [name]: d, toDate: d });
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: d, toDate: d },
          })
        );
      } else {
        setState({ ...state, [name]: d });
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: { ...state, [name]: d },
          })
        );
      }
      if (
        name === 'toDate' &&
        state?.fromDate?.length > 0 &&
        validDate(new Date(state?.fromDate)) === false
      ) {
        localErr = localErr.filter((item) => item.field !== 'fromDate');
        localErr.push({
          field: 'fromDate',
          errorType: 'dateInvalidFormat',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
      }
      if (
        name === 'fromDate' &&
        state?.toDate?.length > 0 &&
        validDate(new Date(state?.toDate)) === false
      ) {
        localErr = localErr.filter((item) => item.field !== 'toDate');
        localErr.push({
          field: 'toDate',
          errorType: 'dateInvalidFormat',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
      }
    }
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
  };
  return (
    <div className="form-wrapper">
      <div className="col-3">
        <div className="mui-custom-form with-select">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              required
              id="begin_date_net_association_bp_tab"
              data-testid="From-date-picker"
              label="From"
              format={dateFormatForDatePicker}
              inputFormat={dateFormatForDatePicker}
              mask="__/__/____"
              minDate={MinDate}
              maxDate={MaxDate}
              value={state?.fromDate}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: false,
                autoFill: false,
              }}
              placeholder="mm/dd/yyyy"
              onChange={(e) => {
                handleOnChangeDateFields(e, 'fromDate');
              }}
              onBlur={(e) => {
                handleChangeDate(e, 'fromDate');
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              onKeyDown={async (e) => {
                if (e.keyCode == 67) {
                  // copy date
                  await window.navigator?.clipboard.writeText(e?.target?.value);
                }
              }}
              className={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'fromDate' ? 'mandate-fields' : null
                    )
                  : null
              }
              helperText={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'fromDate' ? l.message : null
                    )
                  : null
              }
              error={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'fromDate' ? l.message : null
                    )
                  : null
              }
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      <div className="col-3">
        <div className="mui-custom-form with-select">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              required
              id="begin_date_net_association_bp_tab"
              data-testid="To-date-picker"
              label="To"
              format={dateFormatForDatePicker}
              inputFormat={dateFormatForDatePicker}
              mask="__/__/____"
              minDate={state?.fromDate}
              maxDate={MaxDate}
              value={state?.toDate}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: false,
                autoFill: false,
              }}
              placeholder="mm/dd/yyyy"
              onChange={(e) => {
                handleOnChangeDateFields(e, 'toDate');
              }}
              onBlur={(e) => {
                handleChangeDate(e, 'toDate');
              }}
              onKeyDown={async (e) => {
                if (e.keyCode == 67) {
                  // copy date
                  await window.navigator?.clipboard.writeText(e?.target?.value);
                }
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'toDate' ? 'mandate-fields' : null
                    )
                  : null
              }
              helperText={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'toDate' ? l.message : null
                    )
                  : null
              }
              error={
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(errorMessagesFromRedux.searchScreenErrors, (l) =>
                      l.field === 'toDate' ? l.message : null
                    )
                  : null
              }
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      <div className="col-2">
        <div className="btn-wrapper float-right">
          <Button
            className="btn btn-success btn-search mt-4 frr-margin-right-45"
            data-testid="search_btn"
            type="button"
            onClick={() => {
              handleOnSubmit();
            }}
          >
            {'  '} Search
          </Button>
        </div>
      </div>
    </div>
  );
};
